import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { cartActions, customerActions } from "@stores"
import { WPApi } from "@api"
import {
  CartCtx,
  AppCtx,
  useActions,
  useContextState,
} from "@components/contexted"
import { AnimatedButton } from "@components/shared"
import {
  summary__bottom,
  discount__wrapper,
  sum__wrapper,
  price,
} from "../styles/checkout.module.scss"

const DiscountAndContinue = ({ nextStep, label = "Kontynuuj", props, selectedLanguage, translations}) => {
  const [state, setState] = useState({ coupons: [] })
  const { setCoupon } = useActions(CartCtx, ["setCoupon"])
  const { coupon, sum, shipping, items } = useContextState(CartCtx, [
    "coupon",
    "items",
    "sum",
    "shipping",
  ])
  const { imBusy } = useContextState(AppCtx, "imBusy")

  if (state.coupons.length == 0) {
    WPApi.getAllCoupons().then((data) => {
      setState({
        ...state,
        coupons: data,
      })
    })
  }

  let couponAmount = 0
  if (state.coupons) {
    if (coupon) {
      state.coupons.map((el, k) => {
        if (el.code == coupon) {
          couponAmount = el.amount
        }
      })
    }
  }

  return (
    <div className={summary__bottom}>
      <div className={discount__wrapper}>
        <input
          type="text"
          placeholder={translations[selectedLanguage].couponLabel}
          onChange={(ev) => {
            setCoupon(ev.target.value)
          }}
          value={coupon}
        />
      </div>
      <div className={sum__wrapper}>
        <h5>
          {translations[selectedLanguage].sum}{" "}
          <span className={price}>
            {typeof shipping.total === "number"
              ? sum.val + shipping.total
              : sum.val}{" "}
            PLN
          </span>
        </h5>
        {couponAmount != 0 ? (
          <h6>{translations[selectedLanguage].couponValue} {parseInt(couponAmount)} PLN</h6>
        ) : (
          <h6>&nbsp;</h6>
        )}
        <AnimatedButton onClick={nextStep} disabled={imBusy}>
          {imBusy ? translations[selectedLanguage].processingLabel : translations[selectedLanguage].label}
          <i className="icofont-double-right"></i>
        </AnimatedButton>
      </div>
    </div>
  )
}

export default DiscountAndContinue
